import DatabaseModel from './DatabaseModel.js';

var ItemEnriquecido = Object.create(DatabaseModel);

ItemEnriquecido.model = 'itemsenriquecidos';
ItemEnriquecido.modelFront = 'itemsenriquecidos';

/**
 * Eventos del item (colección items_eventos), más reciente primero.
 *
 * @param {String} idItem
 * @returns Promise<Array>
 */
ItemEnriquecido.eventosDeItem = function(idItem) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/eventos',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

/**
 * Reclasifica en tanda los items indicados. No espera al final: la tanda corre en segundo plano
 * y su avance llega por el canal 'reproceso-masivo' del hub SSE.
 */
ItemEnriquecido.reclasificarMasivo = function(ids) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/reclasificar-masivo',
        method: 'POST',
        data: ids || []
    }, false).then(function(res) {
        return (res && res.dto) || res || null;
    });
};

/** Por dónde va la tanda. Se consulta además del SSE, por si el stream no está vivo. */
ItemEnriquecido.estadoReprocesoMasivo = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/reproceso-masivo/estado',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.dto) || res || null;
    });
};

/** Pide parar la tanda en curso: termina el elemento actual y no coge el siguiente. */
ItemEnriquecido.cancelarReprocesoMasivo = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/reproceso-masivo/cancelar',
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        return (res && res.dto) || res || null;
    });
};

/** Reclasifica el item: re-sincroniza sus expedientes contra el maestro actual. Devuelve el item. */
ItemEnriquecido.reclasificar = function(idItem) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/reclasificar',
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        return res && res.dto;
    });
};

/** Edita a mano el valor de una o varias características del item. Devuelve el item actualizado. */
ItemEnriquecido.editarCaracteristicas = function(idItem, cambios) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/caracteristicas',
        method: 'POST',
        data: cambios || []
    }, false).then(function(res) {
        return res && res.dto;
    });
};

/**
 * Una característica de tipo tabla, ya parseada por el servidor. Los tres tipos de tabla se
 * guardan distinto (matriz JSON en TABLA/TABLA_DINAMICA, HTML en TABLA_PERSONALIZADA) y el
 * parseo vive en el back para no mantenerlo también aquí.
 */
ItemEnriquecido.tablaCaracteristica = function(idItem, clave) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem
             + '/caracteristica-tabla?clave=' + encodeURIComponent(clave),
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.dto) || res || null;
    });
};

/**
 * Edita celdas sueltas de una característica de tipo tabla. Se manda fila/columna en vez de la
 * tabla entera porque en TABLA_PERSONALIZADA el valor es el HTML del que salen los informes PDF.
 * celdas = [{clave, fila, columna, valor}] — todas de la misma característica.
 */
ItemEnriquecido.editarCeldasTabla = function(idItem, celdas) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/caracteristica-tabla/celdas',
        method: 'POST',
        data: celdas
    }, false).then(function(res) {
        return (res && res.dto) || res || null;
    });
};

/**
 * Otros items en el mismo emplazamiento físico (mismo placeId). Un sitio suele tener varias
 * instalaciones de reglamentos distintos —una gasolinera: REBT + RITE + IP— y cada una es un
 * item aparte; desde la ficha de uno se ven los demás.
 */
ItemEnriquecido.mismoLugar = function(idItem) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/mismo-lugar',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

/** Roles del item (colección items_roles): vigentes e históricos. */
ItemEnriquecido.rolesDeItem = function(idItem) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + idItem + '/roles',
        method: 'GET',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

/**
 * Solicita al backend el cálculo del ID canónico según la estrategia indicada.
 * No persiste nada — solo calcula.
 *
 * @param {Object} payload  { estrategia: 'MOV'|'FIJ'|'CAL'|'PRV', ...campos }
 * @returns Promise<string>  ID canónico calculado
 */
ItemEnriquecido.generarId = function(payload) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/generar-id',
        method: 'POST',
        data: payload || {}
    }, false).then(function(res) {
        // Backend devuelve { dto: "<id>" } envuelto por ResponseDto
        if (res && typeof res.dto === 'string') return res.dto;
        if (typeof res === 'string') return res;
        return null;
    });
};

export default ItemEnriquecido;
